import { api } from '../index';
import { objectToFormData } from '@/api/util';

const prefix = '/api/invoice/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSoIndex() {
	return api.get(prefix + 'soIndex');
}

export function apiIndexForInvoice() {
	return api.get(prefix + 'indexForInvoice');
}

export function apiInvoiceIndex() {
	return api.get(prefix + 'invoiceIndex');
}

export function apiSelectInvoiceList(param) {
	return api.post(prefix + 'selectInvoiceList', param);
}

export function apiSelectDelayedInvoiceList(param) {
	return api.post(prefix + 'selectDelayedInvoiceList', param);
}

export function apiSelectAbnormalInvoiceList(param) {
	return api.post(prefix + 'selectAbnormalInvoiceList', param);
}

export function apiSelectInvoice(param) {
	return api.post(prefix + 'selectInvoice', param);
}

export function apiSelectInvoiceItemList(param) {
	return api.post(prefix + 'selectInvoiceItemList', param);
}

export function apiSelectPrevInvoiceItemList(param) {
	return api.post(prefix + 'selectPrevInvoiceItemList', param);
}

export function apiSelectInvoiceItemListForMerge(param) {
	return api.post(prefix + 'selectInvoiceItemListForMerge', param);
}

export function apiSelectInvoiceHistoryItemList(param) {
	return api.post(prefix + 'selectInvoiceHistoryItemList', param);
}

export function apiInsertInvoice(param) {
	param.mode = 'insert';
	return apiSubmitInvoice(param);
	//return api.post(prefix + 'submitInvoice', param);
}

export function apiUpdateInvoice(param, status_changed) {
	param.mode = 'update';
	if (status_changed) param.status_changed_yn = 'Y';
	//console.log(param);
	return apiSubmitInvoice(param);
	//return api.post(prefix + 'submitUser', param);
}

// export function apiDeleteUser(param) {
// 	param.mode = 'delete';
// 	return api.post(prefix + 'submitUser', param);
// }

function apiSubmitInvoice(param) {
	return api.post(prefix + 'submitInvoice', param);
}

export function apiCheckInactiveItemExists(param) {
	return api.post(prefix + 'checkInactiveItemExists', param);
}

export function apiSubmitInvoiceAfterBoxing(param, mode) {
	if (mode == 'add') param.mode = 'insert';
	else param.mode = 'update';
	return api.post(prefix + 'submitInvoiceAfterBoxing', param);
}

export function apiPrintPickingTicket(param) {
	return api.post(prefix + 'printPickingTicket', param);
}

export function apiPrintPickingTicketBatch(param) {
	return api.post(prefix + 'printPickingTicketBatch', param);
}

export function apiMakePackedBatch(param) {
	return api.post(prefix + 'makePackedBatch', param);
}

export function apiCompletePacking(param) {
	return api.post(prefix + 'completePacking', param);
}

export function apiCancelPacking(param) {
	return api.post(prefix + 'cancelPacking', param);
}

export function apiAdjustBackOrderItems(param) {
	return api.post(prefix + 'adjustBackOrderItems', param);
}

export function apiSelectBackOrderItemList(param) {
	return api.post(prefix + 'selectBackOrderItemList', param);
}

export function apiUpdateZoneCode(param) {
	return api.post(prefix + 'updateZoneCode', param);
}

export function apiUpdatePriceConfirm(param) {
	return api.post(prefix + 'updatePriceConfirm', param);
}

export function apiTest() {
	return api.get('/test');
}

export function apiInvoicePrintData(invoice_no) {
	return api.get(prefix + 'data/' + invoice_no);
}

export function apiUpdateInvoicePrint(invoice_no) {
	return api.get(prefix + 'update/print', { params: { invoice_no } });
}

export function apiUpdateInvoicePrintList(invoice_no_arr) {
	return api.post(prefix + 'update/print/list', objectToFormData({ invoice_no_arr }));
}

export function apiInvoicePrintDataList(param) {
	return api.get(prefix + 'data/list' + param);
}

export function apiUpdateSalesOrderPrint(invoice_no) {
	return api.get(prefix + 'update/so/print', { params: { invoice_no } });
}

export function apiUpdateSalesOrderListPrint(invoice_no_arr) {
	return api.post(prefix + 'update/so/list/print', objectToFormData({ invoice_no_arr }));
}

export function apiUpdateInvoiceVoid(param) {
	return api.post(prefix + 'updateInvoiceVoid', param);
}

export function apiWaiveInvoice(param) {
	return api.post(prefix + 'waiveInvoice', param);
}

export function apiSelectShipToAddressHistory(param) {
	return api.post(prefix + 'selectShipToAddressHistory', param);
}

export function apiActivateShipToAddress(param) {
	return api.post(prefix + 'activateShipToAddress', param);
}

export function apiSelectInvoiceShipmentOnly(param) {
	return api.post(prefix + 'selectInvoiceShipmentOnly', param);
}

export function apiSelectInvoiceShipment(param) {
	return api.post(prefix + 'selectInvoiceShipment', param);
}

export function apiSelectInvoiceShipmentHistory(invoice_no) {
	return api.get(prefix + 'selectInvoiceShipmentHistory', { params: { invoice_no } });
}

export function apiSelectDeliveryTypeChangeHistory(param) {
	return api.post(prefix + 'selectDeliveryTypeChangeHistory', param);
}

export function apiUpdateInvoiceShipment(param) {
	return api.post(prefix + 'updateInvoiceShipment', param);
}

export function apiProcessShipment(param) {
	return api.post(prefix + 'processShipment', param);
}

export function apiVoidShipment(param) {
	return api.post(prefix + 'voidShipment', param);
}

export function apiInsertShipmentLabelPrintHistory(param) {
	return api.post(prefix + 'insertShipmentLabelPrintHistory', param);
}

export function apiEstimateRating(param) {
	return api.post(prefix + 'estimateRating', param);
}

export function apiSelectRequestPriceList(param) {
	return api.post(prefix + 'selectRequestPriceList', param);
}

export function apiUpdateRequestPrice(param) {
	return api.post(prefix + 'updateRequestPrice', param);
}

export function apiPickingPrintDataList(invoice_nos) {
	return api.post(prefix + 'picking/data/list', invoice_nos);
}

export function apiPackingBoxItem(invoice_no) {
	return api.get(prefix + 'completePacking/boxData/' + invoice_no);
}

export function apiUpdateDescription(param) {
	return api.post(prefix + 'updateDescription', param);
}

export function apiUpdateRemarks(param) {
	return api.post(prefix + 'updateRemarks', param);
}

export function apiUpdateRemarkOnly(param) {
	return api.post(prefix + 'updateRemarkOnly', param);
}

export function apiUpdateSalesGroup(param) {
	return api.post(prefix + 'updateSalesGroup', param);
}

export function apiUpdateSalesMan(param) {
	return api.post(prefix + 'updateSalesMan', param);
}

export function apiUpdateArMemo(param) {
	return api.post(prefix + 'updateArMemo', param);
}

export function apiChangeInvoiceDateBatch(param) {
	return api.post(prefix + 'changeInvoiceDateBatch', param);
}

export function apiSelectPreemptedInvoiceList(param) {
	return api.post(prefix + 'selectPreemptedInvoiceList', param);
}

export function apiSelectTempInvoice(param) {
	return api.post('/api/temp_invoice/' + 'selectTempInvoice', param);
}

export function apiInsertTempInvoice(param) {
	param.mode = 'insert';
	return apiSubmitTempInvoice(param);
}

export function apiUpdateTempInvoice(param) {
	param.mode = 'update';
	return apiSubmitTempInvoice(param);
}

export function apiDeleteTempInvoice(param) {
	param.mode = 'delete';
	return apiSubmitTempInvoice(param);
}

function apiSubmitTempInvoice(param) {
	return api.post('/api/temp_invoice/' + 'submitTempInvoice', param);
}

export function apiTempInvoicePrintData(temp_invoice_no) {
	return api.get('/api/temp_invoice/no/' + temp_invoice_no);
}

export function apiSelectPackingPrintHistory(invoice_no) {
	return api.get(prefix + 'packing-print-history/' + invoice_no);
}

export function apiHoldSalesOrder(param) {
	return api.post(prefix + 'holdSalesOrder', param);
}

export function apiSelectInvoiceItemList4Customer(param) {
	return api.post(prefix + 'selectInvoiceItemList4Customer', param);
}
